import { render, staticRenderFns } from "./LabelFilters.vue?vue&type=template&id=82846324&scoped=true"
import script from "./LabelFilters.vue?vue&type=script&lang=ts"
export * from "./LabelFilters.vue?vue&type=script&lang=ts"
import style0 from "./LabelFilters.vue?vue&type=style&index=0&id=82846324&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82846324",
  null
  
)

export default component.exports